<template>
    <div class="form-container">
        <div class="columns">
            <h4 class="column is-three-quarters">
                <span id="form-title-top">{{
                    $t("Please choose your destinations")
                }}</span>
            </h4>
        </div>
        <div class="columns">
            <div class="column">
                <div class="columns">
                    <div class="column is-9">
                        <div class="address_choises">
                            <h6
                                :class="[
                                    'title active-border',
                                    { active: this.from.id != -1 },
                                ]"
                            >
                                <span
                                    :class="[
                                        'dot',
                                        { active: this.from.id != -1 },
                                    ]"
                                ></span>
                                {{ $t("Shipper") }}
                            </h6>
                            <b-field
                                id="addressType"
                                v-if="from.id == -1 && activeModal !== 1"
                            >
                                <b-dropdown aria-role="list">
                                    <div class="select-address" slot="trigger">
                                        {{
                                            primaryAddresses.includes(1)
                                                ? $t("Primary addresses")
                                                : primaryAddresses.includes(3)
                                                ? isStore
                                                    ? $t("Customers addresses")
                                                    : $t("Friends' addresses")
                                                : $t(
                                                      "-- Choose shipper address --"
                                                  )
                                        }}
                                    </div>

                                    <b-dropdown-item
                                        aria-role="listitem"
                                        @click="toggleMenu(3, 1)"
                                        >{{
                                            $t("Primary addresses")
                                        }}</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                        aria-role="listitem"
                                        @click="toggleMenu(1, 3)"
                                        >{{
                                            isStore
                                                ? $t("Customers addresses")
                                                : $t("Friends' addresses")
                                        }}</b-dropdown-item
                                    >
                                </b-dropdown>
                            </b-field>
                            <div
                                class="add-address"
                                v-if="from.id == -1 && activeModal !== 1"
                            >
                                <p>{{ $t("Have a Diffrent Address?") }}</p>
                                <button
                                    @click="
                                        activeModal = 1;
                                        person = 'shipper';
                                    "
                                >
                                    {{ $t("Add Address") }}
                                </button>
                            </div>
                        </div>
                        <template v-if="activeModal !== 1">
                            <div
                                v-if="
                                    primary_addresses.length &&
                                    primaryAddresses.includes(1)
                                "
                            >
                                <ul>
                                    <template
                                        v-for="(
                                            address, i
                                        ) in primary_addresses"
                                    >
                                        <li
                                            class="addressItemParent"
                                            v-if="
                                                from.id == address.id ||
                                                from.id == -1
                                            "
                                            :key="i"
                                        >
                                            <div
                                                :class="[
                                                    'addressItem',
                                                    {
                                                        active:
                                                            from.id ==
                                                            address.id,
                                                    },
                                                ]"
                                            >
                                                <div
                                                    style="
                                                        display: flex;
                                                        justify-content: space-between;
                                                        margin: 0 5px;
                                                    "
                                                >
                                                    <div>
                                                        <p class="name">
                                                            {{
                                                                address.full_name
                                                            }}
                                                        </p>
                                                        <p class="address">
                                                            {{ address.city }}
                                                            {{
                                                                address.country
                                                                    .nice_name
                                                            }}
                                                        </p>
                                                    </div>

                                                    <div
                                                        class="check-mark"
                                                        v-show="
                                                            from.id ==
                                                            address.id
                                                        "
                                                    >
                                                        <img
                                                            class="check"
                                                            src="@/assets/images/green-check.svg"
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    class="box-option"
                                                    style="margin: 5px 0 0"
                                                >
                                                    <button
                                                        slot="trigger"
                                                        aria-controls="choose_from_address"
                                                        @click.stop="
                                                            toggleIsFromOpen(i)
                                                        "
                                                        class="show-more"
                                                        v-show="
                                                            from.id !=
                                                            address.id
                                                        "
                                                    >
                                                        {{
                                                            isFromOpen != i
                                                                ? $t(
                                                                      "More details"
                                                                  )
                                                                : $t(
                                                                      "Less details"
                                                                  )
                                                        }}
                                                    </button>
                                                    <button
                                                        slot="trigger"
                                                        aria-controls="choose_from_address"
                                                        @click.stop="
                                                            addressFrom(
                                                                address,
                                                                i
                                                            )
                                                        "
                                                        class="show-more"
                                                        style="margin: 0 5px"
                                                        v-show="
                                                            from.id !=
                                                            address.id
                                                        "
                                                    >
                                                        {{
                                                            $t("Choose address")
                                                        }}
                                                    </button>
                                                    <button
                                                        slot="trigger"
                                                        aria-controls="choose_from_address"
                                                        @click.stop="
                                                            addressFrom(
                                                                address,
                                                                null,
                                                                true
                                                            )
                                                        "
                                                        class="show-more"
                                                        style="margin: 0 5px"
                                                    >
                                                        {{
                                                            $t("Update address")
                                                        }}
                                                    </button>
                                                </div>
                                            </div>
                                            <b-collapse
                                                :open="isFromOpen == i"
                                                aria-id="choose_from_address"
                                                animation="slide"
                                            >
                                                <div
                                                    :class="[
                                                        'address-view',
                                                        {
                                                            active:
                                                                from.id ==
                                                                address.id,
                                                        },
                                                    ]"
                                                >
                                                    <!-- <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{ $t("Email") }}:
                                                        </p>
                                                        <p>
                                                            {{ address.email }}
                                                        </p>
                                                    </div> -->
                                                    <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{ $t("Phone:") }}
                                                        </p>
                                                        <p
                                                            style="
                                                                direction: ltr !important;
                                                            "
                                                        >
                                                            +{{
                                                                address.mobile
                                                            }}
                                                        </p>
                                                    </div>
                                                    <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Company name:"
                                                                )
                                                            }}
                                                        </p>
                                                        <p>
                                                            {{
                                                                address.company
                                                            }}
                                                        </p>
                                                    </div>

                                                    <div
                                                        class="view-item"
                                                        style="flex-wrap: wrap"
                                                    >
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{
                                                                $t("Location:")
                                                            }}
                                                        </p>
                                                        <div
                                                            style="
                                                                width: 100%;
                                                                direction: ltr;
                                                            "
                                                        >
                                                            <p>
                                                                {{
                                                                    address.address_one
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    address.address_two
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    `${
                                                                        address.city
                                                                    } ${
                                                                        address.state
                                                                            ? ", " +
                                                                              address.state
                                                                            : ""
                                                                    } ${
                                                                        address.postal_code
                                                                            ? "- " +
                                                                              address.postal_code
                                                                            : ""
                                                                    }`
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    address
                                                                        .country
                                                                        .nice_name
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        style="
                                                            display: flex;
                                                            justify-content: flex-end;
                                                        "
                                                    >
                                                        <Loading
                                                            v-if="loading"
                                                        />
                                                        <button
                                                            v-if="!loading"
                                                            class="button"
                                                            style="
                                                                font-size: 12px;
                                                                color: #000;
                                                                background: none;
                                                                text-decoration: underline;
                                                                border: none;
                                                            "
                                                            @click.stop="
                                                                addToPrimaryAddress(
                                                                    address.id,
                                                                    0
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Remove from my primary addresses"
                                                                )
                                                            }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                            <div
                                v-if="
                                    primaryAddresses.includes(3) ||
                                    (from.id != -1 &&
                                        !primaryAddresses.includes(1))
                                "
                            >
                                <div class="input-field" v-if="from.id == -1">
                                    <input
                                        class="interior"
                                        :placeholder="
                                            $t('Search with name or email ...')
                                        "
                                        type="text"
                                        tabindex="0"
                                        v-model="fromSearch"
                                    />
                                </div>
                                <ul>
                                    <template
                                        v-for="(address, i) in addressess.slice(
                                            0,
                                            this.fromLimit
                                        )"
                                    >
                                        <li
                                            class="addressItemParent"
                                            v-if="
                                                (from.id == address.id ||
                                                    from.id == -1) &&
                                                addressess.length
                                            "
                                            :key="i"
                                        >
                                            <div
                                                :class="[
                                                    'addressItem',
                                                    {
                                                        active:
                                                            from.id ==
                                                            address.id,
                                                    },
                                                ]"
                                            >
                                                <div style="width: 100%">
                                                    <div
                                                        style="
                                                            display: flex;
                                                            justify-content: space-between;
                                                            margin: 0 5px;
                                                        "
                                                    >
                                                        <div>
                                                            <p class="name">
                                                                {{
                                                                    address.full_name
                                                                }}
                                                            </p>
                                                            <p class="address">
                                                                {{
                                                                    address.city
                                                                }}
                                                                {{
                                                                    address
                                                                        .country
                                                                        .nice_name
                                                                }}
                                                            </p>
                                                        </div>
                                                        <div
                                                            class="check-mark"
                                                            v-show="
                                                                from.id ==
                                                                address.id
                                                            "
                                                        >
                                                            <img
                                                                class="check"
                                                                src="@/assets/images/green-check.svg"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="box-option">
                                                        <button
                                                            slot="trigger"
                                                            aria-controls="choose_from_address"
                                                            @click.stop="
                                                                toggleIsFromOpen(
                                                                    i
                                                                )
                                                            "
                                                            class="show-more"
                                                            v-show="
                                                                from.id !=
                                                                address.id
                                                            "
                                                        >
                                                            {{
                                                                isFromOpen != i
                                                                    ? $t(
                                                                          "More details"
                                                                      )
                                                                    : $t(
                                                                          "Less details"
                                                                      )
                                                            }}
                                                        </button>
                                                        <button
                                                            slot="trigger"
                                                            style="
                                                                margin: 0 5px;
                                                            "
                                                            aria-controls="choose_from_address"
                                                            @click.stop="
                                                                addressFrom(
                                                                    address,
                                                                    i
                                                                )
                                                            "
                                                            class="show-more"
                                                            v-show="
                                                                from.id !=
                                                                address.id
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Choose address"
                                                                )
                                                            }}
                                                        </button>
                                                        <button
                                                            slot="trigger"
                                                            style="
                                                                margin: 0 5px;
                                                            "
                                                            aria-controls="choose_from_address"
                                                            @click.stop="
                                                                addressFrom(
                                                                    address,
                                                                    null,
                                                                    true
                                                                )
                                                            "
                                                            class="show-more"
                                                            v-show="
                                                                from.id !=
                                                                address.id
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Update address"
                                                                )
                                                            }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <b-collapse
                                                :open="isFromOpen == i"
                                                aria-id="choose_from_address"
                                                animation="slide"
                                            >
                                                <div
                                                    :class="[
                                                        'address-view',
                                                        {
                                                            active:
                                                                from.id ==
                                                                address.id,
                                                        },
                                                    ]"
                                                >
                                                    <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{ $t("Email") }}:
                                                        </p>
                                                        <p>
                                                            {{ address.email }}
                                                        </p>
                                                    </div>
                                                    <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{ $t("Phone:") }}
                                                        </p>
                                                        <p
                                                            style="
                                                                direction: ltr !important;
                                                            "
                                                        >
                                                            +{{
                                                                address.mobile
                                                            }}
                                                        </p>
                                                    </div>
                                                    <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Company name:"
                                                                )
                                                            }}
                                                        </p>
                                                        <p>
                                                            {{
                                                                address.company
                                                            }}
                                                        </p>
                                                    </div>

                                                    <div
                                                        class="view-item"
                                                        style="flex-wrap: wrap"
                                                    >
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{
                                                                $t("Location:")
                                                            }}
                                                        </p>
                                                        <div
                                                            style="
                                                                width: 100%;
                                                                direction: ltr;
                                                            "
                                                        >
                                                            <p>
                                                                {{
                                                                    address.address_one
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    address.address_two
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    `${
                                                                        address.city
                                                                    } ${
                                                                        address.state
                                                                            ? ", " +
                                                                              address.state
                                                                            : ""
                                                                    } ${
                                                                        address.postal_code
                                                                            ? "- " +
                                                                              address.postal_code
                                                                            : ""
                                                                    }`
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    address
                                                                        .country
                                                                        .nice_name
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        style="
                                                            display: flex;
                                                            justify-content: flex-end;
                                                        "
                                                        v-if="
                                                            !primary_addresses.filter(
                                                                (address) =>
                                                                    address.id ==
                                                                    from.id
                                                            ).length
                                                        "
                                                    >
                                                        <Loading
                                                            v-if="loading"
                                                        />
                                                        <button
                                                            v-if="
                                                                !loading &&
                                                                from.id != -1
                                                            "
                                                            class="button"
                                                            style="
                                                                font-size: 12px;
                                                                background: none;
                                                                border: none;
                                                                color: #000;
                                                                text-decoration: underline;
                                                            "
                                                            @click="
                                                                addToPrimaryAddress(
                                                                    from.id,
                                                                    1
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Add to my primary addresses"
                                                                )
                                                            }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </li>
                                    </template>
                                    <li
                                        style="margin-top: 10px"
                                        class="danger"
                                        v-if="!addressess.length"
                                    >
                                        <p>
                                            {{
                                                $t(
                                                    "There is no title saved with this name, please add a new title"
                                                )
                                            }}
                                        </p>
                                    </li>
                                    <p
                                        class="more-addresses"
                                        @click="fromLimit += 4"
                                        v-if="
                                            from.id == -1 &&
                                            addressess.length > 4
                                        "
                                        style="
                                            color: #777;
                                            margin-top: 15px;
                                            text-align: center;
                                            font-size: 18px;
                                        "
                                    >
                                        <span>{{
                                            addressess.length - fromLimit
                                        }}</span>
                                        <span style="margin: 0 5px">{{
                                            $t("More addresses")
                                        }}</span>
                                    </p>
                                </ul>
                            </div>
                            <div class="active-options" v-if="from.id != -1">
                                <button
                                    class="button option"
                                    @click="
                                        isFromOpen == currFrom
                                            ? (isFromOpen = null)
                                            : (isFromOpen = currFrom)
                                    "
                                >
                                    {{
                                        isFromOpen === null
                                            ? $t("More details")
                                            : $t("Less details")
                                    }}
                                </button>
                                <button
                                    class="button option"
                                    @click="addressFrom(from, null)"
                                >
                                    {{ $t("Choose another address") }}
                                </button>
                            </div>
                        </template>
                        <template
                            v-if="activeModal == 1 && person == 'shipper'"
                        >
                            <add-address
                                :person="person"
                                :addressData="addressData"
                                @sendFrom="
                                    addressFrom($event.address, $event.index)
                                "
                                @sendTo="
                                    addressTo($event.address, $event.index)
                                "
                                @cancel="activeModal = 0"
                            ></add-address>
                        </template>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="columns">
                    <div
                        class="column is-9"
                        v-if="this.from.id != -1 || this.to.id != -1"
                    >
                        <div class="address_choises">
                            <h6
                                :class="[
                                    'title active-border',
                                    { active: this.to.id != -1 },
                                ]"
                            >
                                <span
                                    :class="[
                                        'dot',
                                        { active: this.to.id != -1 },
                                    ]"
                                ></span>
                                {{ $t("Recipient") }}
                            </h6>
                            <b-field
                                id="addressType"
                                v-if="to.id == -1 && activeModal !== 2"
                            >
                                <b-dropdown aria-role="list">
                                    <div class="select-address" slot="trigger">
                                        {{
                                            primaryAddresses.includes(2)
                                                ? $t("Primary addresses")
                                                : primaryAddresses.includes(4)
                                                ? isStore
                                                    ? $t("Customers addresses")
                                                    : $t("Friends' addresses")
                                                : $t(
                                                      "-- Choose recipient address --"
                                                  )
                                        }}
                                    </div>

                                    <b-dropdown-item
                                        aria-role="listitem"
                                        @click="toggleMenu(4, 2)"
                                        >{{
                                            $t("Primary addresses")
                                        }}</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                        aria-role="listitem"
                                        @click="toggleMenu(2, 4)"
                                        >{{
                                            isStore
                                                ? $t("Customers addresses")
                                                : $t("Friends' addresses")
                                        }}</b-dropdown-item
                                    >
                                </b-dropdown>
                            </b-field>
                            <div
                                class="add-address"
                                v-if="to.id == -1 && activeModal !== 2"
                            >
                                <p>{{ $t("Have a Diffrent Address?") }}</p>
                                <button
                                    @click="
                                        activeModal = 2;
                                        person = 'recipient';
                                    "
                                >
                                    {{ $t("Add Address") }}
                                </button>
                            </div>
                        </div>
                        <template v-if="activeModal !== 2">
                            <div
                                v-if="
                                    primary_addresses.length &&
                                    primaryAddresses.includes(2)
                                "
                            >
                                <ul>
                                    <template
                                        v-for="(
                                            address, i
                                        ) in primary_addresses"
                                    >
                                        <li
                                            class="addressItemParent"
                                            v-if="
                                                to.id == address.id ||
                                                to.id == -1
                                            "
                                            :key="i"
                                        >
                                            <div
                                                :class="[
                                                    'addressItem',
                                                    {
                                                        active:
                                                            to.id == address.id,
                                                    },
                                                ]"
                                            >
                                                <div style="width: 100%">
                                                    <div
                                                        style="
                                                            display: flex;
                                                            justify-content: space-between;
                                                            margin: 0 5px;
                                                        "
                                                    >
                                                        <div>
                                                            <p class="name">
                                                                {{
                                                                    address.full_name
                                                                }}
                                                            </p>
                                                            <p class="address">
                                                                {{
                                                                    address.city
                                                                }}
                                                                {{
                                                                    address
                                                                        .country
                                                                        .nice_name
                                                                }}
                                                            </p>
                                                        </div>
                                                        <div
                                                            class="check-mark"
                                                            v-show="
                                                                to.id ==
                                                                address.id
                                                            "
                                                        >
                                                            <img
                                                                class="check"
                                                                src="@/assets/images/green-check.svg"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    class="box-option"
                                                    style="margin: 5px 0 0"
                                                >
                                                    <button
                                                        slot="trigger"
                                                        aria-controls="choose_to_address"
                                                        @click.stop="
                                                            toggleIsToOpen(i)
                                                        "
                                                        class="show-more"
                                                        v-show="
                                                            to.id != address.id
                                                        "
                                                    >
                                                        {{
                                                            isToOpen != i
                                                                ? $t(
                                                                      "More details"
                                                                  )
                                                                : $t(
                                                                      "Less details"
                                                                  )
                                                        }}
                                                    </button>
                                                    <button
                                                        slot="trigger"
                                                        style="margin: 0 5px"
                                                        aria-controls="choose_from_address"
                                                        @click.stop="
                                                            addressTo(
                                                                address,
                                                                i
                                                            )
                                                        "
                                                        class="show-more"
                                                        v-show="
                                                            to.id != address.id
                                                        "
                                                    >
                                                        {{
                                                            $t("Choose address")
                                                        }}
                                                    </button>
                                                    <button
                                                        slot="trigger"
                                                        style="margin: 0 5px"
                                                        aria-controls="choose_from_address"
                                                        @click.stop="
                                                            addressTo(
                                                                address,
                                                                null,
                                                                true
                                                            )
                                                        "
                                                        class="show-more"
                                                    >
                                                        {{
                                                            $t("Update address")
                                                        }}
                                                    </button>
                                                </div>
                                            </div>
                                            <b-collapse
                                                :open="isToOpen == i"
                                                aria-id="choose_to_address"
                                                animation="slide"
                                            >
                                                <div
                                                    class="address-view"
                                                    :class="[
                                                        'address-view',
                                                        {
                                                            active:
                                                                to.id ==
                                                                address.id,
                                                        },
                                                    ]"
                                                >
                                                    <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{ $t("Email") }}:
                                                        </p>
                                                        <p>
                                                            {{ address.email }}
                                                        </p>
                                                    </div>
                                                    <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{ $t("Phone:") }}
                                                        </p>
                                                        <p
                                                            style="
                                                                direction: ltr !important;
                                                            "
                                                        >
                                                            +{{
                                                                address.mobile
                                                            }}
                                                        </p>
                                                    </div>
                                                    <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Company name:"
                                                                )
                                                            }}
                                                        </p>
                                                        <p>
                                                            {{
                                                                address.company
                                                            }}
                                                        </p>
                                                    </div>

                                                    <div
                                                        class="view-item"
                                                        style="flex-wrap: wrap"
                                                    >
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{
                                                                $t("Location:")
                                                            }}
                                                        </p>
                                                        <div
                                                            style="
                                                                width: 100%;
                                                                direction: ltr;
                                                            "
                                                        >
                                                            <p>
                                                                {{
                                                                    address.address_one
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    address.address_two
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    `${
                                                                        address.city
                                                                    } ${
                                                                        address.state
                                                                            ? ", " +
                                                                              address.state
                                                                            : ""
                                                                    } ${
                                                                        address.postal_code
                                                                            ? "- " +
                                                                              address.postal_code
                                                                            : ""
                                                                    }`
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    address
                                                                        .country
                                                                        .nice_name
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        style="
                                                            display: flex;
                                                            justify-content: flex-end;
                                                        "
                                                    >
                                                        <Loading
                                                            v-if="loading"
                                                        />
                                                        <button
                                                            v-if="!loading"
                                                            class="button"
                                                            style="
                                                                font-size: 12px;
                                                                color: #000;
                                                                background: none;
                                                                border: none;
                                                                text-decoration: underline;
                                                            "
                                                            @click="
                                                                addToPrimaryAddress(
                                                                    address.id,
                                                                    0
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Remove from my primary addresses"
                                                                )
                                                            }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                            <div
                                v-if="
                                    primaryAddresses.includes(4) ||
                                    (to.id != -1 &&
                                        !primaryAddresses.includes(2))
                                "
                            >
                                <div class="input-field" v-if="to.id == -1">
                                    <input
                                        class="interior"
                                        :placeholder="
                                            $t('Search with name or email ...')
                                        "
                                        type="text"
                                        tabindex="0"
                                        v-model="toSearch"
                                    />
                                </div>
                                <ul>
                                    <template
                                        v-for="(
                                            address, i
                                        ) in addressessTo.slice(
                                            0,
                                            this.toLimit
                                        )"
                                    >
                                        <li
                                            class="addressItemParent"
                                            v-if="
                                                to.id == address.id ||
                                                to.id == -1
                                            "
                                            :key="i"
                                        >
                                            <div
                                                :class="[
                                                    'addressItem',
                                                    {
                                                        active:
                                                            to.id == address.id,
                                                    },
                                                ]"
                                            >
                                                <div style="width: 100%">
                                                    <div
                                                        style="
                                                            margin: 0 5px;
                                                            display: flex;
                                                            justify-content: space-between;
                                                        "
                                                    >
                                                        <div>
                                                            <p class="name">
                                                                {{
                                                                    address.full_name
                                                                }}
                                                            </p>
                                                            <p class="address">
                                                                {{
                                                                    address.city
                                                                }}
                                                                {{
                                                                    address
                                                                        .country
                                                                        .nice_name
                                                                }}
                                                            </p>
                                                        </div>
                                                        <div
                                                            class="check-mark"
                                                            v-show="
                                                                to.id ==
                                                                address.id
                                                            "
                                                        >
                                                            <img
                                                                class="check"
                                                                src="@/assets/images/green-check.svg"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="box-option"
                                                        style="margin: 5px 0 0"
                                                    >
                                                        <button
                                                            slot="trigger"
                                                            aria-controls="choose_to_address"
                                                            @click.stop="
                                                                toggleIsToOpen(
                                                                    i
                                                                )
                                                            "
                                                            class="show-more"
                                                            v-show="
                                                                to.id !=
                                                                address.id
                                                            "
                                                        >
                                                            {{
                                                                isToOpen != i
                                                                    ? $t(
                                                                          "More details"
                                                                      )
                                                                    : $t(
                                                                          "Less details"
                                                                      )
                                                            }}
                                                        </button>
                                                        <button
                                                            slot="trigger"
                                                            style="
                                                                margin: 0 5px;
                                                            "
                                                            aria-controls="choose_to_address"
                                                            @click.stop="
                                                                addressTo(
                                                                    address,
                                                                    i
                                                                )
                                                            "
                                                            class="show-more"
                                                            v-show="
                                                                to.id !=
                                                                address.id
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Choose address"
                                                                )
                                                            }}
                                                        </button>
                                                        <button
                                                            slot="trigger"
                                                            style="
                                                                margin: 0 5px;
                                                            "
                                                            aria-controls="choose_to_address"
                                                            @click.stop="
                                                                addressTo(
                                                                    address,
                                                                    null,
                                                                    true
                                                                )
                                                            "
                                                            class="show-more"
                                                        >
                                                            {{
                                                                $t(
                                                                    "Update address"
                                                                )
                                                            }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <b-collapse
                                                :open="isToOpen == i"
                                                aria-id="choose_from_address"
                                                animation="slide"
                                            >
                                                <div
                                                    :class="[
                                                        'address-view',
                                                        {
                                                            active:
                                                                to.id ==
                                                                address.id,
                                                        },
                                                    ]"
                                                >
                                                    <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{ $t("Email") }}:
                                                        </p>
                                                        <p>
                                                            {{ address.email }}
                                                        </p>
                                                    </div>
                                                    <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{ $t("Phone:") }}
                                                        </p>
                                                        <p
                                                            style="
                                                                direction: ltr !important;
                                                            "
                                                        >
                                                            +{{
                                                                address.mobile
                                                            }}
                                                        </p>
                                                    </div>
                                                    <div class="view-item">
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Company name:"
                                                                )
                                                            }}
                                                        </p>
                                                        <p>
                                                            {{
                                                                address.company
                                                            }}
                                                        </p>
                                                    </div>

                                                    <div
                                                        class="view-item"
                                                        style="flex-wrap: wrap"
                                                    >
                                                        <p
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            {{
                                                                $t("Location:")
                                                            }}
                                                        </p>
                                                        <div
                                                            style="
                                                                width: 100%;
                                                                direction: ltr;
                                                            "
                                                        >
                                                            <p>
                                                                {{
                                                                    address.address_one
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    address.address_two
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    `${
                                                                        address.city
                                                                    } ${
                                                                        address.state
                                                                            ? ", " +
                                                                              address.state
                                                                            : ""
                                                                    } ${
                                                                        address.postal_code
                                                                            ? "- " +
                                                                              address.postal_code
                                                                            : ""
                                                                    }`
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    address
                                                                        .country
                                                                        .nice_name
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        style="
                                                            display: flex;
                                                            justify-content: flex-end;
                                                        "
                                                        v-if="
                                                            !primary_addresses.filter(
                                                                (address) =>
                                                                    address.id ==
                                                                    to.id
                                                            ).length
                                                        "
                                                    >
                                                        <Loading
                                                            v-if="loading"
                                                        />
                                                        <button
                                                            v-if="
                                                                !loading &&
                                                                to.id != -1
                                                            "
                                                            class="button"
                                                            style="
                                                                font-size: 12px;
                                                                background: none;
                                                                border: none;
                                                                color: #000;
                                                                text-decoration: underline;
                                                            "
                                                            @click="
                                                                addToPrimaryAddress(
                                                                    to.id,
                                                                    1
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Add to my primary addresses"
                                                                )
                                                            }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </li>
                                    </template>
                                    <p
                                        @click="toLimit += 4"
                                        v-if="
                                            to.id == -1 &&
                                            addressessTo.length > 4
                                        "
                                        style="
                                            color: #777;
                                            margin-top: 15px;
                                            text-align: center;
                                            font-size: 18px;
                                        "
                                    >
                                        <span>{{
                                            addressessTo.length - toLimit
                                        }}</span>
                                        <span style="margin: 0 5px">{{
                                            $t("More addresses")
                                        }}</span>
                                    </p>
                                </ul>
                            </div>
                            <div class="active-options" v-if="to.id != -1">
                                <button
                                    class="button option"
                                    @click="
                                        isToOpen == currTo
                                            ? (isToOpen = null)
                                            : (isToOpen = currTo)
                                    "
                                >
                                    {{
                                        isToOpen === null
                                            ? $t("More details")
                                            : $t("Less details")
                                    }}
                                </button>
                                <button
                                    class="button option"
                                    @click="addressTo(to, null)"
                                >
                                    {{ $t("Choose another address") }}
                                </button>
                            </div>
                        </template>
                        <template
                            v-if="activeModal == 2 && person == 'recipient'"
                        >
                            <add-address
                                :person="person"
                                :addressData="addressData"
                                @sendFrom="
                                    addressFrom($event.address, $event.index)
                                "
                                @sendTo="
                                    addressTo($event.address, $event.index)
                                "
                                @cancel="activeModal = 0"
                            ></add-address>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            :active.sync="isRequestAddress"
            trap-focus
            aria-role="dialog"
            aria-modal
            scroll="clip"
        >
            <request-address />
        </b-modal>
    </div>
</template>

<script>
import Loading from "@/components/Loading";
import { globalEvent } from "@/main";
import AddAddress from "@/components/sections/addAddressSection.vue";
import requestAddress from "@/components/modal/requestAddress.vue";
export default {
    components: {
        Loading,
        AddAddress,
        requestAddress,
    },
    data() {
        return {
            activeModal: 0,
            fromIsSet: false,
            toIsSet: false,
            S_notify: false,
            R_notify: false,
            person: false,
            showErrors: false,
            isRequestAddress: false,
            loading: false,
            isFromOpen: null,
            isToOpen: null,
            fromSearch: "",
            toSearch: "",
            primaryAddresses: [],
            currFrom: null,
            currTo: null,
            fromLimit: 4,
            toLimit: 4,
            addressData: null,
        };
    },
    watch: {
        from: {
            immediate: true,
            handler(val) {
                if (val.id != -1 && this.to.id != -1) {
                    if (
                        val.country == "Saudi Arabia" &&
                        this.to.country == "Saudi Arabia"
                    ) {
                        this.$store.dispatch("domestic_rate", true);
                    } else {
                        this.$store.dispatch("domestic_rate", false);
                    }
                    this.$emit("finish", true);
                    return;
                }
                this.$emit("finish", false);
            },
        },
        to: {
            immediate: true,
            handler(val) {
                if (val.id != -1 && this.from.id != -1) {
                    if (
                        val.country == "Saudi Arabia" &&
                        this.from.country == "Saudi Arabia"
                    ) {
                        this.$store.dispatch("domestic_rate", true);
                    } else {
                        this.$store.dispatch("domestic_rate", false);
                    }
                    this.$emit("finish", true);
                    return;
                }
                this.$emit("finish", false);
            },
        },
    },
    methods: {
        toggleIsFromOpen(i) {
            if (this.isFromOpen == i) return (this.isFromOpen = null);
            this.isFromOpen = i;
        },
        toggleIsToOpen(i) {
            if (this.isToOpen == i) return (this.isToOpen = null);
            this.isToOpen = i;
        },
        toggleMenu(remove, add) {
            this.primaryAddresses = this.primaryAddresses.filter(
                (i) => i != remove
            );
            this.primaryAddresses.push(add);
        },
        addToPrimaryAddress(id, status) {
            this.loading = true;
            if (this.primary_addresses.length > 4 && status == 1) {
                this.$buefy.toast.open({
                    message: this.$t(
                        "You have exceeded the limit of 5 addresses"
                    ),
                    type: "is-primary",
                });
                this.loading = false;
                return;
            }
            this.$store
                .dispatch("primary_address", {
                    id: id,
                    status: status,
                })
                .then((res) => {
                    setTimeout(() => {
                        this.loading = false;
                    }, 1000);
                });
        },
        checkNext() {
            if (this.from.id == -1) return false;

            return true;
        },
        showAllError() {
            this.showErrors = true;
        },
        hideForm() {
            this.$el.classList.add("hide-form-container");
        },
        addressFrom(arg, i = null, editState) {
            if ((i && !arg.city_id) || editState) {
                this.person = "shipper";
                this.addressData = arg;
                this.activeModal = 1;
                return;
            } else {
                this.addressData = null;
                this.activeModal = 0;
            }

            if (this.currFrom == i) {
                this.currFrom = null;
            } else {
                this.currFrom = i;
            }
            let s = {
                full_name: arg.full_name,
                street: `${arg.address_one}`,
                address_two: `${arg.address_two}`,
                city: arg.city,
                state: arg.state,
                country: arg.country ? arg.country.nice_name : null,
                zip: arg.postal_code,
                email: arg.email,
                phone: arg.mobile,
                company: arg.company,
                id: arg.id,
            };
            setTimeout(() => {
                globalEvent.$emit("s1changed");
                this.$store.dispatch("sendFrom", s);
            }, 0);
        },
        addressTo(arg, i = null, editState) {
            if ((i && !arg.city_id) || editState) {
                this.person = "recipient";
                this.addressData = arg;
                this.activeModal = 2;
                return;
            } else {
                this.addressData = null;
                this.activeModal = 0;
            }
            if (this.currTo == i) {
                this.currTo = null;
            } else {
                this.currTo = i;
            }
            let s = {
                full_name: arg.full_name,
                street: `${arg.address_one}`,
                address_two: `${arg.address_two}`,
                city: arg.city,
                state: arg.state,
                country: arg.country ? arg.country.nice_name : null,
                zip: arg.postal_code,
                email: arg.email,
                phone: arg.mobile,
                company: arg.company,
                id: arg.id,
            };

            setTimeout(() => {
                globalEvent.$emit("s1changed");
                this.$store.dispatch("sendTo", s);
            }, 0);
        },
        // removePicked(type) {
        //     this.$store.dispatch("removePicked", type);
        // },
        allowNext() {
            let check = this.checkNext();
            if (!check) return false;
            return this.from.id != -1 && this.to.id != -1;
        },
    },
    computed: {
        isStore() {
            return this.$store.state.userData.is_store;
        },
        addressBook() {
            return this.$store.getters.addressBook;
        },
        from() {
            return this.$store.getters.shipment.sendFrom;
        },
        to() {
            return this.$store.getters.shipment.sendTo;
        },
        addressess() {
            this.fromLimit = 4;
            let query = new RegExp(this.fromSearch, "i");
            let rawData = this.$store.state.addressBook;
            if (!rawData.length) return;
            return rawData.filter((address) => {
                return query.test(
                    `${address.full_name} ${address.address_one} ${address.mobile} ${address.email}`
                );
            });
        },
        addressessTo() {
            this.toLimit = 4;
            let query = new RegExp(this.toSearch, "i");
            let rawData = this.$store.state.addressBook;
            if (!rawData.length) return;
            return rawData.filter((address) => {
                return query.test(
                    `${address.full_name} ${address.address_one} ${address.mobile} ${address.email}`
                );
            });
        },
        primary_addresses() {
            let rawData = this.$store.state.addressBook;
            if (!rawData.length) return [];
            return rawData.filter((address) => address.is_basic);
        },
    },
    created() {
        this.$store.dispatch("address", null);
        if (this.from.id == -1 || this.to.id == -1) {
            localStorage.setItem("form1", null);
        } else {
            let obj = JSON.parse(localStorage.getItem("form1"));
            this.primaryAddresses = obj.primaryAddresses;
            this.currFrom = obj.currFrom;
            this.currTo = obj.currTo;
        }
    },
    beforeDestroy() {
        let obj = {
            primaryAddresses: this.primaryAddresses,
            currFrom: this.currFrom,
            currTo: this.currTo,
        };

        localStorage.setItem("form1", JSON.stringify(obj));
    },
};
</script>

<style lang="scss" scoped>
.is-9 {
    position: relative;
}

.dot {
    width: 10px;
    height: 10px;
    background: #ddd;
    display: inline-block;
    margin: 0 5px;
    border-radius: 50%;

    &.active {
        background: #000;
    }
}

.danger {
    color: #ff7977;
    text-align: center;
}

.check-mark {
    background: #50e3c270;
    border-radius: 10px;
    width: 40px;
    height: 40px;
    text-align: center;
    vertical-align: center;
    line-height: 10px;
    margin: 0 15px;

    .check {
        width: 20px;
        height: 20px;
        margin-top: 11px;
    }
}

.active-options {
    position: absolute;
    right: 25px;
    top: 140px;
}

#addressType {
    padding: 0 15px;
}

.box-option {
    text-align: right;

    &:lang(ar) {
        text-align: left;
    }
}

.add-address {
    display: flex;
    align-items: center;
    margin: 0 20px;
    font-size: 16px;

    p {
        margin: 0;
        color: #777;
    }

    button {
        font-size: 16px;
        border: none;
        background: none;
        color: #4952ff;
        outline: none !important;
        cursor: pointer;

        &:focus {
            outline: none !important;
        }
    }
}

.select-address {
    width: 400px !important;
    text-align: center !important;
    color: #000 !important;
    border: 1px solid #ddd;
    padding: 7px 0;
    border-radius: 7px;
    cursor: pointer;
}

::v-deep {
    .dropdown-menu {
        width: 100% !important;
    }
}

.active-border {
    border-bottom: 4px solid #ddd;
    width: 140px;
    display: flex;
    align-items: center;

    &.active {
        border-color: #000;
    }
}

.expand {
    border-radius: 50px !important;
    width: 30px;
    height: 29px;
    padding: 4px 5px !important;
    border-color: #ccc !important;

    img {
        width: 100%;
    }

    &:lang(ar) {
        transform: rotate(180deg);
    }
}

.addressItemParent {
    margin: 10px;
    border-radius: 15px !important;
    overflow: hidden !important;

    .addressItem {
        cursor: pointer;
        background: #f7f7f7;
        padding: 15px;
        width: 100%;
        border-radius: 15px 15px 0 0;

        &.active {
            background: #50e3c235;
            height: 130px;
        }

        i {
            padding: 0 10px;
        }

        .name {
            font-size: 20px;
            margin-bottom: 0;
            padding: 0 10px;
        }

        .address {
            font-size: 14px;
            color: #777;
            padding: 0 10px;
        }
    }
}

.show-more {
    background: #e8e8e8 !important;
    border: none !important;
    padding: 7px 20px;
    border-radius: 50px;
    outline: none !important;
    cursor: pointer;

    &:active {
        outline: none !important;
    }
}

.input-field {
    background-color: #fff;
    padding: 0;
    margin-bottom: 10px;
    border-radius: 50px;
    border: 1px solid #ddd;
    margin: 10px 10px 0;
    position: relative;

    input {
        color: #000;
        width: 100%;
        text-align: center;
        background-color: transparent;
        padding: 10px 10px;
        font-size: 1rem;
        font-weight: bold;
        outline: none;

        &:focus {
            outline: none;
        }
    }
}

.button.option {
    margin: 0 10px;
    padding: 5px 15px !important;
    height: 27px !important;
    color: #000;
    border-radius: 7px !important;
    background: #50e3c295 !important;
    border: none !important;
}

.address_choises {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    .title {
        font-size: 24px;
        margin-bottom: 8px;
        margin-right: 14px;
        font-weight: bold;
        opacity: 0.7;
    }

    ul {
        display: flex;
        justify-content: flex-start;

        li {
            padding: 0 10px;
            margin: 5px;
            border: 1px solid #ddd;
            border-radius: 7px;
            cursor: pointer;

            &.active {
                background: #838ec3;
                color: white;
            }
        }
    }
}

i {
    font-size: 27px;
    opacity: 0.5;
}

.bg-light-gray {
    background-color: #dedede;
    color: white;
}

.form-container {
    padding: 1.5rem 1.5rem 3rem 1.5rem;
    box-sizing: inherit;
    transition: 0.4s ease-out;
    opacity: 1;

    #form-title-top {
        margin-bottom: 25px;
        display: inline-block;
        font-size: 25px;
    }
}

.hide-form-container {
    opacity: 0;
}

.address-view {
    padding: 15px 5px 10px 30px;
    width: 100%;
    background: #f7f7f7;
    border-radius: 0 0 15px 15px;

    &.active {
        background: #50e3c235;
    }

    .view-item {
        display: flex;
        align-items: center;
        padding: 8px 0;

        img {
            width: 30px;
            height: 30px;
            opacity: 0.3;
        }

        p {
            padding: 0 10px;
            margin: 0;
        }
    }
}

::v-deep {
    .modal-background {
        opacity: 0.8 !important;
    }
}

@media screen and (max-width: 1240px) {
    .is-9 {
        width: 90% !important;
    }

    .h6.title {
        font-size: 20px !important;
    }

    .select-address {
        width: 250px !important;
        font-size: 14px !important;
    }

    .check-mark {
        width: 30px;
        height: 30px;
        margin: 0 5px;

        .check {
            width: 15px;
            height: 15px;
            margin-top: 8px;
        }
    }

    .input-field input {
        font-size: 14px !important;
    }
}

@media screen and (max-width: 500px) {
    .is-9 {
        width: 100% !important;
    }

    h4.is-three-quarters span {
        font-size: 22px !important;
    }

    .form-container {
        padding: 10px !important;
    }

    button {
        font-size: 12px !important;
    }

    .name {
        font-size: 18px !important;
    }

    .address {
        font-size: 12px !important;
    }

    .add-address {
        font-size: 14px !important;
    }

    .more-addresses {
        font-size: 16px !important;
    }
}
</style>
